module.exports = __webpack_public_path__ + "static/media/40-11.0c0b4dc2.mp3";